
  import { Component, Vue } from 'vue-property-decorator';
  import { Client, ScheduledJobItemModel } from '@/services/api.service';
  import { JobType, EnumModel, JobTypeEnums } from '@/common/enumerations';
  import * as DateUtils from '@/utilities/date.utils';
  import { IWallboardNetwork, IWallboardTask, WallboardNetwork, WallboardTask } from './WallboardModels';
  import { JobItemType } from '@/common/enumerations';
  import WallboardTable from './WallboardTable.vue';
  import toDateFormatter from '@/filters/todate.formatter';

  @Component({
    components: {
      WallboardTable
    },
    filters: {
      toDate: toDateFormatter,
    }
  })
  export default class Wallboard extends Vue {
    private auditingJobs: IWallboardNetwork[] = [];
    private detailingJobs: IWallboardNetwork[] = [];
    private lastUpdatedDateTime: string = '';
    private currentDate: Date = new Date();

    private mounted() {
      // get the scheduled jobs for today
      this.executeAutoRefresh();
    }

    private startAutoRefreshOfJobs() {
      // Refresh rates:
      // 6:00am - 7:59am - every 10 seconds
      // 8:00am - 3:59pm - every 30 seconds
      // 4:00pm - 5:59am - every 2 minutes

      const interval = this.getTimerIntervalInSeconds();
      setTimeout(() => {
        this.executeAutoRefresh();
      }, interval * 1000);
    }

    private executeAutoRefresh() {
      this.refreshTodaysJobs();
      this.startAutoRefreshOfJobs();
    }

    private getTimerIntervalInSeconds(): number {
      const currentDate = new Date();
      const currentTimeInSeconds =
        currentDate.getHours() * 3600 + currentDate.getMinutes() * 60 + currentDate.getSeconds();
      // 6am :
      if (currentTimeInSeconds >= 21600 && currentTimeInSeconds < 28800) {
        // 6:00am - 8:00am
        return 10;
      }
      if (currentTimeInSeconds >= 28800 && currentTimeInSeconds < 57600) {
        // 6:00am - 8:00am
        return 30;
      }
      return 120;
    }

    private refreshTodaysJobs() {
      let dr = new Date();

      // for my sanity, the '+' unary operator converts string to a number
      const fromDate: number = DateUtils.toIsoDate(dr);
      dr = DateUtils.addDays(dr, 1);
      const toDate: number = fromDate; // DateUtils.toIsoDate(dr);

      const clientService: Client = new Client(process.env.VUE_APP_API_URL, this.$http);

      // Set jobtype to 0 (Mixed) for the search
      clientService.getTodaysScheduledJobItems().then(data => {
        // Clear the data first
        this.auditingJobs = [];
        this.detailingJobs = [];
        data.forEach(item => {
          // determine if it is an auditing or detailing task
          // and which network it belongs to

          // Drafting, Design and Project Management tasks are to be ignored from the list
          // Detailing and Underground Locating tasks are Detailing, all others are Auditing

          if (item.jobItemType) {
            const theItemType = (item.jobItemType as unknown) as JobItemType;
            const ignoreTask =
              theItemType === JobItemType.Drafting ||
              theItemType === JobItemType.ProjectManagement ||
              theItemType === JobItemType.Design ||
              theItemType === JobItemType.Admin;

            if (!ignoreTask) {
              const isAuditingTask = !(
                theItemType === JobItemType.Detailing || theItemType === JobItemType.UndergroundLocating
              );

              let theNetwork: IWallboardNetwork | undefined;
              if (isAuditingTask) {
                theNetwork = this.findOrCreateWallboardNetwork(item, this.auditingJobs);
              } else {
                theNetwork = this.findOrCreateWallboardNetwork(item, this.detailingJobs);
              }
              // create the item and push
              const theTask = new WallboardTask();
              theTask.gid = item.jobItemGid || '';
              theTask.location = (item.location && item.location.address) || '';
              theTask.suburb = (item.location && item.location.suburb) || '';
              theTask.serviceType = (item.serviceType && item.serviceType.name) || '';
              theTask.name = item.name || '';
              theTask.assignee = item.assignedToEmployee || '';
              if (!theNetwork.tasks) {
                theNetwork.tasks = [];
              }
              theNetwork.tasks.push(theTask);
            }
          }
        });

        this.lastUpdatedDateTime = new Date().toLocaleTimeString();
      });
    }

    private findOrCreateWallboardNetwork(item: ScheduledJobItemModel, networks: IWallboardNetwork[]) {
      let theNetwork: IWallboardNetwork | undefined;
      if (item.network && networks) {
        theNetwork = networks.find(n => n.name === ((item.network && item.network.name) || ''));
      }
      if (!theNetwork) {
        // Create it
        theNetwork = new WallboardNetwork();
        theNetwork.gid = item.networkGid || '';
        theNetwork.name = (item.network && item.network.name) || '';
        theNetwork.hexColor = (item.network && item.network.hexColor) || '';
        networks.push(theNetwork);
      }

      return theNetwork;
    }
  }
